import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { t } from '@kso/ui/lib/config/locale';
import forbiddenImg from '@kso/ui/lib/images/yun-error.png';
import { TipWarningTips } from '@kdocs/kdesign-icons-vue';
import '@kso/ui/lib/CertificationForbidden/style.css';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CertificationForbidden = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-certification-forbidden"
    }, [!_vm.type ? _c('div', {
      staticClass: "k-forbidden-normal"
    }, [_c('div', {
      staticClass: "k-forbidden-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.forbiddenImg,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "k-forbidden-title",
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(_vm.forbiddenTitle))]), _vm._v(" "), _c('p', {
      staticClass: "k-forbidden-desc",
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(_vm.forbiddenDesc))])]) : _c('div', {
      staticClass: "k-forbidden-create-share"
    }, [_c('div', {
      staticClass: "k-forbidden-icon"
    }, [_c('TipWarningTips', {
      attrs: {
        "size": "100px",
        "fill": "currentColor"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "k-forbidden-title",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('div', {
      staticClass: "title-row"
    }, [_vm._v("\n        " + _vm._s(_vm.shownForbiddenTitle) + "\n      ")]), _vm._v(" "), _vm.shownForbiddenInfo ? _c('div', {
      staticClass: "title-row"
    }, [_vm._v("\n        " + _vm._s(_vm.shownForbiddenInfo) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "k-forbidden-desc",
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(_vm.forbiddenText)), _c('br'), _vm._v(_vm._s(_vm.forbiddenSuggestion))])])]);
  },
  staticRenderFns: [],
  name: 'KCertificationForbidden',
  components: {
    TipWarningTips: TipWarningTips
  },
  props: {
    type: {
      type: String,
      "default": '',
      required: false
    },
    forbiddenMsg: {
      type: String,
      "default": '',
      required: false
    },
    onDwEvent: {
      type: Function,
      "default": null,
      required: false
    }
  },
  data: function data() {
    return {
      forbiddenImg: forbiddenImg,
      // 临时封禁用户、永久封禁用户相关
      forbiddenText: t('basic.certification.forbiddenText'),
      forbiddenSuggestion: t('basic.certification.forbiddenSuggestion'),
      shownForbiddenTitle: t('basic.certification.forbiddenReasonPer'),
      shownForbiddenInfo: ''
    };
  },
  computed: {
    forbiddenTitle: function forbiddenTitle() {
      return t('basic.certification.forbiddenTitle');
    },
    forbiddenDesc: function forbiddenDesc() {
      return t('basic.certification.forbiddenDesc');
    }
  },
  created: function created() {
    this.createShareInit();
    this.dwEvent({
      action: 'show'
    });
  },
  methods: {
    createShareInit: function createShareInit() {
      if (this.type === 'TemporarilyBlockSharing') {
        // 临时封禁用户
        var time = this.forbiddenMsg.replace(/[^0-9]/ig, '');
        var timestamp = parseInt(time);
        if (typeof timestamp === 'number') {
          var timeStr = this.getFormatExpiredTime(timestamp);
          this.shownForbiddenInfo = t('basic.certification.forbiddenReasonTemAttemp', {
            time: timeStr
          });
        }
      }
    },
    /**
     * 暂时封禁用户：获取封禁过期显示时间
     *
     * @param {Number} timestamp unix时间戳
     */
    getFormatExpiredTime: function getFormatExpiredTime(timestamp) {
      var expireTime = new Date(timestamp * 1000);
      var year = expireTime.getFullYear();
      var month = expireTime.getMonth() + 1;
      var day = expireTime.getDate();
      var hour = expireTime.getHours();
      var minute = expireTime.getMinutes();
      var second = expireTime.getSeconds();
      return "".concat(year, "-").concat(this.formatNumber(month), "-").concat(this.formatNumber(day)) + " ".concat(this.formatNumber(hour), ":").concat(this.formatNumber(minute), ":").concat(this.formatNumber(second));
    },
    /**
     * 日期、时间如果是一位就补0
     *
     * @param {Number} number
     */
    formatNumber: function formatNumber(number) {
      if (number <= 9) {
        return '0' + number;
      }
      return number;
    },
    /**
     * 封禁
     * @param {*} params
     */
    dwEvent: function dwEvent(params) {
      if (this.type) {
        var newParams = _objectSpread({
          type: this.type === 'TemporarilyBlockSharing' ? 'ban_popup_shortterm' : 'ban_popup_forever',
          action: params.action || 'click'
        }, params);
        // 临时封禁、永久封禁需求的埋点
        if (this.onDwEvent && typeof this.onDwEvent === 'function') {
          // sharev3通过js调用
          this.onDwEvent('share_ban_popup', newParams);
        } else {
          // personalShareFile、sharev2等地方通过模板调用
          this.$emit('onDwEvent', 'share_ban_popup', newParams);
        }
      }
    }
  }
};

CertificationForbidden.install = function (Vue) {
  Vue.component(CertificationForbidden.name, CertificationForbidden);
};

export { CertificationForbidden as default };
